import { ref } from 'vue';

import { useMetricDetails } from '@/app/dashboards/composables/useMetricDetails';
import { getAveragedMetricFormula } from '@/app/dashboards/utils/metrics.utils.js';
import { POST_TYPE_SECTION_TITLE } from '@/models/dashboards/metrics.constants';

export function getMetricDetails(metric, channels, metricTypeReportKey) {
  const {
    allowContentTags,
    connectedAccountsOnly,
    dataSource,
    dataType,
    deprecated,
    displayName,
    formatMetricValue,
    graphBeginAtZero,
    graphPrecision,
    graphStats,
    isGalleryMetric,
    isNegativeMetric,
    lockedMediaBreakdown,
    mediaTypeLabel,
    parentMetric,
    permissions,
    postType,
    requiredFeatureFlag,
    sourceDataName,
    supportsMediaBreakdown,
    timeframe,
    tooltip,
  } = useMetricDetails({
    metric: ref(metric),
    channels: ref(channels),
    metricReportTypeKey: ref(metricTypeReportKey),
  });
  return {
    allowContentTags: allowContentTags.value,
    connectedAccountsOnly: connectedAccountsOnly.value,
    dataSource: dataSource.value,
    dataType: dataType.value,
    deprecated: deprecated.value,
    displayName: displayName.value,
    formatMetricValue,
    graphBeginAtZero: graphBeginAtZero.value,
    graphPrecision: graphPrecision.value,
    graphStats: graphStats.value,
    isGalleryMetric: isGalleryMetric.value,
    isNegativeMetric: isNegativeMetric.value,
    lockedMediaBreakdown: lockedMediaBreakdown.value,
    mediaTypeLabel: mediaTypeLabel.value,
    parentMetric: parentMetric.value,
    permissions: permissions.value,
    postType: postType.value,
    requiredFeatureFlag: requiredFeatureFlag.value,
    sourceDataName: sourceDataName.value,
    supportsMediaBreakdown: supportsMediaBreakdown.value,
    timeframe: timeframe.value,
    tooltip: tooltip.value,
  };
}

export function getMetricDescriptionTooltip({
  metricTitle,
  isAveraged,
  baseMetricName,
  baseTooltip,
  formula,
  timeframe,
  postType,
  channels,
}) {
  let tooltipContent = baseTooltip || undefined;
  if (isAveraged && tooltipContent && baseMetricName) {
    tooltipContent = `${baseMetricName}: ${tooltipContent}`;
  }

  let tooltipFormula = formula;
  if (isAveraged) {
    tooltipFormula =
      getAveragedMetricFormula({
        baseMetricName,
        timeframe,
        postType,
      }) ?? tooltipFormula;
  }
  const postTypeLabel =
    postType && channels && channels.length === 1
      ? `Distribution Type: ${POST_TYPE_SECTION_TITLE[postType] ?? postType}`
      : null;
  const footerParts = [tooltipFormula, postTypeLabel].filter(Boolean);
  const tooltipFooter = footerParts.length > 0 ? footerParts.join('\n\n') : undefined;
  const tooltipIcon =
    tooltipContent || tooltipFooter
      ? {
          title: metricTitle,
          content: tooltipContent,
          footer: tooltipFooter,
        }
      : null;
  return tooltipIcon;
}

export function filterMetricsWithParentMetric(channels, allMetricDetails, metricTypeReportKey) {
  return (metric) =>
    channels.every(
      (channel) => !allMetricDetails?.[channel]?.[metricTypeReportKey]?.[metric]?.parent_metric,
    );
}
